module.exports = __webpack_public_path__ + "static/media/iuc.0a527963.jpg";